export default {
  apiKey: "AIzaSyCW_-uEzyhdnLMy1dIvdj3yn0_kNzMy_vg",
  authDomain: "testjewerkgeluk.firebaseapp.com",
  databaseURL: "https://testjewerkgeluk.firebaseio.com",
  projectId: "testjewerkgeluk",
  storageBucket: "testjewerkgeluk.appspot.com",
  messagingSenderId: "808650980286",
  appId: "1:808650980286:web:7f2152419befcbf0f617ef",
  appCheckSiteKey: "6LfmF6MtAAAAAJY_4_-w02zjuwHHk9K1wVWZ9N9B"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfigProd.js